module.exports = __webpack_public_path__ + "img/guandai_xc1.12dc6ef1.jpg";